import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45430f45"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mt-4" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Пользователь с данным номером не зарегистрирован", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Вы исчерпали все попытки. Попробуйте позже", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = { class: "mt-8 text--center" }

import { ref, onMounted } from 'vue';
import SberId from '@/views/auth/components/SberId.vue';
import Masks from '@/helpers/masks';


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthByPhone',
  props: {
  isPhoneDisabled: {
    type: Boolean,
    default: false,
  },
  isTemporaryBanned: {
    type: Boolean,
    default: false,
  },
  lastAttempt: {
    type: Boolean,
    default: false,
  },
  tooManyRequest: {
    type: Boolean,
    default: false,
  },
  hasError: {
    type: Boolean,
    default: false,
  },
},
  emits: ['update:phone', 'loginByEmail', 'register', 'submit'],
  setup(__props, { emit }) {

const props = __props;



const phone = ref('');
const phoneRef = ref();

onMounted(() => {
  setTimeout(() => phoneRef.value.focus(), 200);
});

const updatePhone = () => emit('update:phone', phone.value);
const loginByEmail = () => emit('loginByEmail');
const register = () => emit('register');
const submit = () => {
  if (props.isPhoneDisabled) {
    return;
  }
  emit('submit', phone.value);
};

return (_ctx: any,_cache: any) => {
  const _component_UiInput = _resolveComponent("UiInput")!
  const _component_UiButton = _resolveComponent("UiButton")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_UiInput, {
      ref_key: "phoneRef",
      ref: phoneRef,
      modelValue: phone.value,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((phone).value = $event)),
        updatePhone
      ],
      placeholder: "Телефон",
      size: "large",
      mask: { mask: _unref(Masks).phone },
      error: __props.hasError,
      onPressEnter: submit
    }, null, 8, ["modelValue", "mask", "error"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_UiButton, {
        class: "button-submit",
        type: "primary",
        size: "large",
        disabled: __props.isPhoneDisabled,
        onClick: submit
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Войти ")
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    _createElementVNode("p", {
      class: _normalizeClass(["auth-view--error text--small text--center error--text mt-2", { active: __props.hasError }])
    }, [
      (__props.isTemporaryBanned)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode("Вы исчерпали все попытки. Попробуйте позже")
          ], 64))
        : (__props.lastAttempt)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _hoisted_2,
              _hoisted_3
            ], 64))
          : (__props.tooManyRequest)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createTextVNode("Превышен лимит запросов"),
                _hoisted_4,
                _createTextVNode(" ")
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _createTextVNode("Пользователь с данным номером не зарегистрирован")
              ], 64))
    ], 2),
    _createVNode(_component_UiButton, {
      class: "mt-8 button-loginby-email",
      size: "large",
      onClick: loginByEmail
    }, {
      default: _withCtx(() => [
        _createTextVNode("Войти по Email")
      ]),
      _: 1
    }),
    _createVNode(SberId, { class: "mt-4" }),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_UiButton, {
        type: "link",
        size: "large",
        onClick: register
      }, {
        default: _withCtx(() => [
          _createTextVNode("Зарегистрироваться")
        ]),
        _: 1
      })
    ])
  ]))
}
}

})